import { render, staticRenderFns } from "./ModelNotes.vue?vue&type=template&id=069701cb&"
import script from "./ModelNotes.vue?vue&type=script&lang=js&"
export * from "./ModelNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports